import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import firebaseInit from '../shared/firebase-init'
export default class AuthService {
  static init() {
    return firebaseInit()
  }
  static onAuthStateChanged(callbackSuccess, callbackError) {
    return firebase.auth().onAuthStateChanged(callbackSuccess, callbackError)
  }
  static signout() {
    return firebase.auth().signOut()
  }
}